import GenericController from './../generic.controller'

export default class Controller extends GenericController {

    constructor(...args) {

        super(...args);

        this.$scope.currentPromise = null;
        this.users = [];
        this.setUsers();

        this.enteredUserCode = this.$rootScope.$on('enteredUserCode', (event, userCode) => {
            this.tryToSetUser(userCode);
        });

        this.setAccessTagLearnModalEvent();

        this.statuseMessages = [
            this.gettext('Learn access tag timeout expired'),
            this.gettext('Access tag successfully learned'),
        ];

        this.$element.on('$destroy', () => {
            this.enteredUserCode();
            this.UiHelper.closeModals();
            if (this.stopAccessTagLearnStateIntervalPointer) {
                this.stopLearnAccessTag();
            }
        });
    }

    setUsers() {
        this.$scope.currentPromise = this.getUsers().then(resp => {
            this.users = resp.data;
        });
    }

    _showUserCodeModal() {
        this.askUserCode()
            .then(userCode => {
                if (userCode) {
                    this.tryToSetUser(userCode)
                }
            }).catch(() => {
            this.$state.reload();
        });
    }

    _showModal(modalName) {
        this.$scope.userCode = '';
        this.showModal(modalName);
    }

    addUser(userCode) {
        this.currentUserObj.areas = _.values(this.currentUserObj.areas);
        this._genericResponseHandle(this._PanelsService.addPanelUser(this.panelId, this.currentUserObj, userCode));
    }

    onDeleteUser(userId) {
        this.currentUserId = userId;
        this._showModal('deleteUserModal');
    }

    tryToDeleteUser(userCode) {
        this._genericResponseHandle(this._PanelsService.deletePanelUser(this.panelId, this.currentUserId, userCode))
    }

    _genericResponseHandle(func) {

        this.ModalDialogService.isModalClosed = false;
        if (this.currentUserObj) {
            if (this.currentUserObj.hasOwnProperty('areas')) {
                this.currentUserObj.areas = this.removeFalsyFromArray(this.currentUserObj.areas);
                if (this.currentUserObj.areas.length == 0 && this.requestType == 'add') {
                    delete this.currentUserObj.areas;
                }
            }
        }
        this.$scope.currentPromise = func.then(() => {
            this.ModalDialogService.isModalClosed = true;
            this.popMessage(this.currentUserObj.name + ' ' + this.updateOKText);
        }).catch(err => {
            this.ModalDialogService.isModalClosed = true;
            this.popMessage(err.data.message, 'error');
        }).finally(setTimeout(this.setUsers.bind(this), 1000));

    }

    _setUser(userCode, userObject) {
        this._genericResponseHandle(this._PanelsService.changePanelUser(this.panelId, userObject, userCode));
    }

    UpdateUser(userCode) {
        this._setUser(userCode, this.currentUserObj);
    }

    onEditAddUser(user, requestType = 'update') {
        this.requestType = requestType;
        this.currentUserObj = user;
        this._showModal('editUserModal');
    }

    deleteAccessTag(userCode) {
        this._genericResponseHandle(this._PanelsService.deleteAccessTag(this.panelId, this.currentUserObj.id, userCode));
    }

    tryToSetUser(userCode) {

        if (this.requestType == 'update') {
            this.UpdateUser(userCode);
        }
        if (this.requestType == 'add') {
            this.addUser(userCode);
        }
        if (this.requestType == 'learnAccessTag') {
            this.learnAccessTag(userCode);
        }
        if (this.requestType == 'deleteAccessTag') {
            this.deleteAccessTag(userCode);
        }
    }

    removeFalsyFromArray(areaList) {
        return areaList.filter(x => x !== null && x !== false);
    }


    stopLearnAccessTag() {
        if (this.stopAccessTagLearnStateIntervalPointer) {
            this._PanelsService.stopAccessTagLearning(this.panelId, this.$scope.userCode);
            this.$timeout.cancel(this.learnAccessTagLoopTimer);
            this.$interval.cancel(this.stopAccessTagLearnStateIntervalPointer);
            this.stopAccessTagLearnStateIntervalPointer = null;
            this.ModalDialogService.isModalClosed = true;

        }
    }

    setAccessTagLearnModalEvent() {
        $('#learnAccessTagModal').on('hidden.bs.modal', () => {
            this.stopLearnAccessTag()
        });
    }

    showLearnAccessTagModal() {
        this.learningAccessTag = null;
        this.accessTagtimeoutEnds = false;
        this.isAccessTagLearned = false;
        this.setAccessTagLearnMessage('');
        this.UiHelper.showModal('learnAccessTagModal');
    }

    tryToLearnAccessTag() {
        this.UiHelper.closeModals();
        this.requestType = 'learnAccessTag';
        this._showModal('userCodeModal');
    }

    tryToDeleteAccessTag() {
        this.UiHelper.closeModals();
        this.requestType = 'deleteAccessTag';
        this._showModal('userCodeModal');
    }

    learnAccessTag(userCode) {

        this.ModalDialogService.isModalClosed = false;
        this.UiHelper.closeModals();
        this.showLearnAccessTagModal();
        this._PanelsService.learnAccessTag(this.panelId, this.currentUserObj.id, userCode).then(resp => {

            this.learningAccessTag = resp.data.state;
            this.stopAccessTagLearnStateIntervalPointer = this.$interval(this.getAccessTagLearnState.bind(this), 1500);
            this.learnAccessTagLoopTimer = this.$timeout(() => {
                this.endAccessTagTimeout();
            }, 90000)
        }).catch(err => {
            this.ModalDialogService.isModalClosed = true;
            this.setAccessTagLearnMessage(err.data.message);
        })
    }

    endAccessTagTimeout() {
        if (this.stopAccessTagLearnStateIntervalPointer) {
            this.accessTagtimeoutEnds = true;
            this.setAccessTagLearnMessage(this.getTranslatableText('Learn access tag timeout expired'));
            this.stopLearnAccessTag();
        }
    }

    getAccessTagLearnState() {

        this._PanelsService.getAccessTagLearnState(this.panelId).then(resp => {

            this.isAccessTagLearned = resp.data.is_learned;

            if (this.isAccessTagLearned) {
                // todo: set user {"is_access_tag_user": true} field (should be on server? - ask alex)
                this.setAccessTagLearnMessage(this.getTranslatableText('Access tag successfully learned'));
                this.stopLearnAccessTag();
            }
        })
    }

    setAccessTagLearnMessage(msg) {
        this.accessTagLearnStateMessage = msg;
    }

}


/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/users.component/controller.js
 **/